
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <circle cx="11.989" cy="3.99475" r="2"></circle><path opacity="0.5" d="M11.989 13.9947C10.8844 13.9947 9.98901 13.0992 9.98901 11.9947C9.98901 10.8901 10.8844 9.99468 11.989 9.99468M11.989 13.9947C13.0936 13.9947 13.989 13.0992 13.989 11.9947C13.989 10.8901 13.0936 9.99468 11.989 9.99468M11.989 13.9947L12.0054 17.9889M11.989 9.99468L11.989 5.99304M12.0054 17.9889C10.9008 17.9889 10.0054 18.8844 10.0054 19.9889C10.0054 21.0935 10.9008 21.9889 12.0054 21.9889C13.1099 21.9889 14.0054 21.0935 14.0054 19.9889C14.0054 18.8844 13.1099 17.9889 12.0054 17.9889Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiVerticalSteps",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
